export default function Button({
  children,
  variant,
  type,
  onClick,
  ariaLabel,
  disabled,
  className = '',
}) {
  const variants = {
    primary: 'bg-custom-light-blue text-white hover:bg-sky-600 transition-colors duration-300',
    outline:
      'border-2 border-custom-light-blue text-white hover:border-white hover:text-custom-light-blue transition-all duration-300',
    secondary:
      'bg-white text-custom-dark-blue hover:bg-sky-600 hover:text-white transition-colors duration-300',
    add: 'bg-custom-light-blue text-white rounded-r-none rounded-l-md hover:bg-sky-600 transition-colors duration-300',
    edit: 'bg-blue-900 text-white rounded-none hover:bg-blue-800 transition-colors duration-300',
    disable:
      'bg-gray-500 text-white rounded-l-none rounded-r-md hover:bg-gray-600 transition-colors duration-300',
    enable:
      'bg-green-500 text-white rounded-l-none rounded-r-md hover:bg-green-600 transition-colors duration-300',
    delete:
      'bg-red-400 text-white rounded-l-none rounded-r-md hover:bg-red-500 transition-colors duration-300',
    cancel: 'bg-gray-300 text-gray-700 hover:bg-gray-400 transition-colors duration-300',
    confirm: 'bg-custom-light-blue text-white hover:bg-sky-600 transition-colors duration-300',
    continue: 'bg-custom-light-blue text-white hover:bg-sky-600 transition-colors duration-300',
    light:
      'bg-white rounded-[8px] shadow-[0_0_9px_rgba(0,0,0,0.15)] cursor-pointer hover:bg-gray-200',
  };

  return (
    <button
      className={`w-full mt-auto sm:w-auto px-4 py-2 text-md font-semibold rounded-md shadow-md ${className} ${
        variants[variant]
      } ${disabled ? 'opacity-20 cursor-not-allowed' : ''} `}
      type={type}
      onClick={onClick}
      aria-label={ariaLabel}
      disabled={disabled}
    >
      {children}
    </button>
  );
}
